import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';


const RoleBasedRoute = ({ children, is_admin }) => {
    const { user } = useSelector((state) => state.auth);

    const role = user?.role || user?.roles || user?.user_account_type;
 
    const allowedRoles = is_admin
        ? ['super_admin', 'manager', 'editor']
        : ['customer'];
  
    if (!role) {
        return <Navigate to="/login" />;

    }

    if (is_admin) {
        if (allowedRoles.includes(role)) {
            return children;
        } else if (role === 'customer') {
            return <Navigate to="/unauthorized" />;
        }
        else {
            return <Navigate to="/" />;
        }
    }
    else {

        if (role === 'customer') {
            return children;
        } else if (['super_admin', 'manager', 'editor'].includes(role)) {
            return <Navigate to="/unauthorized" />;
        }
        else {
            return <Navigate to="/admin" />;
        }
    }
};

export default RoleBasedRoute;